import defaultShareIcon from "@assets/social_media/shareicon.svg";
import ShareSocial, {
  type SocialVariant,
} from "@elements/ShareSocial/ShareSocial";
import { isMobileOrTablet } from "@helper/utils";
import cx from "classnames";
import { useEffect, useRef, useState } from "react";
import { twMerge } from "tailwind-merge";

export type ShareSocialProps = {
  socialIconList: string[];
  pagePath: string;
  deskClassName?: string;
  mbPopupClassName?: string;
  className?: string;
  shareIcon?: string;
  quickNews?: boolean;
  onClickGaEvent?: () => void;
};

export default function ShareSocialButton({
  socialIconList,
  pagePath,
  className,
  mbPopupClassName,
  shareIcon,
  quickNews,
  onClickGaEvent,
}: ShareSocialProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const shareData = {
    url: pagePath,
  };
  // Toggle the dropdown menu
  const toggleDropdown = () => {
    if (isMobileOrTablet()) {
      try {
        void navigator.share(shareData);
      } catch (err) {
        setIsOpen((prev) => !prev);
      }
    } else {
      setIsOpen((prev) => !prev);
    }

    if (onClickGaEvent) {
      onClickGaEvent();
    }
  };

  // Close the dropdown if clicked outside
  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    // Add event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up the event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isQuick = quickNews;

  const buttonClass = twMerge(
    "mb-2.5 px-2.5 dropdown-button",
    isQuick && "mb-0",
  );

  const iconSize = isQuick ? 24 : 15;
  const iconSrc = shareIcon ?? defaultShareIcon;

  const popupClass = cx(
    "grid gap-2.5 bg-white z-10 justify-center rounded-3xl p-2.5 w-12 absolute -ml-1.5",
    mbPopupClassName,
    isQuick && "w-auto !flex px-1 py-1 -top-6 right-4 border border-grey-800",
  );

  return (
    <div ref={dropdownRef} className={className}>
      <button onClick={toggleDropdown} className={buttonClass}>
        <img
          src={iconSrc}
          alt={"share-mb"}
          width={iconSize}
          height={iconSize}
          className="mr-1.5"
          loading="lazy"
        />
      </button>

      {isOpen && (
        <div className={popupClass}>
          {socialIconList.map((variant, index) => (
            <ShareSocial
              variant={variant as SocialVariant}
              pagePath={pagePath}
              key={index}
            />
          ))}
        </div>
      )}
    </div>
  );
}
